<template>
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="4.5" cy="4.5" r="4.5" fill="white" />
        <path
            d="M4.49967 7.41666C2.89142 7.41666 1.58301 6.10825 1.58301 4.5C1.58301 2.89175 2.89142 1.58333 4.49967 1.58333C6.10792 1.58333 7.41634 2.89175 7.41634 4.5C7.41634 6.10825 6.10792 7.41666 4.49967 7.41666Z"
            fill="#EA3C39"
        />
        <path d="M3.04102 4.0625H5.95768V4.9375H3.04102V4.0625Z" fill="white" />
    </svg>
</template>
